module.exports = __webpack_public_path__ + "img/feedback_correct.43c25233.gif";